import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import * as DTO from "../../interfaces";
import { Page, Post, PostDetails, PostSearchQuery, PostSocialNetworkUpdatePayload, PostStatsResponse } from "./dtos";

const POST_SERVICE = `${Constants.API_URL}/bedrock/posts`;

export interface PostFilters {
  playerId?: number;
  search?: string;
  sourceType?: DTO.SourceType | DTO.SourceType[];
  socialNetworkPostStatus?: DTO.SocialNetworkPostStatus | null | (DTO.SocialNetworkPostStatus | null)[];
  page?: number;
  perPage?: number;
  sort?: "created_date" | "updated_date";
  order?: "asc" | "desc";
}

export class PostServices {
  @scCatchServiceException()
  static async getPosts(filters?: PostFilters): Promise<Page<Post>> {
    const { data } = await axios.get<Page<Post>>(POST_SERVICE, {
      params: filters,
    });
    return data;
  }

  @scCatchServiceException()
  static async getPost(postId: number): Promise<PostDetails> {
    const { data } = await axios.get<PostDetails>(`${POST_SERVICE}/${postId}`);
    return data;
  }

  @scCatchServiceException()
  static async getPostStats(postId: number): Promise<PostStatsResponse> {
    const { data } = await axios.get<PostStatsResponse>(`${POST_SERVICE}/${postId}/stats`);
    return data;
  }

  @scCatchServiceException()
  static async search(query: PostSearchQuery): Promise<Page<PostDetails>> {
    const url = `${POST_SERVICE}/search`;
    const { data } = await axios.post(url, query);
    return data;
  }

  @scCatchServiceException()
  static async retryAll(postId: number): Promise<void> {
    await axios.post(`${POST_SERVICE}/${postId}/retry`);
  }

  @scCatchServiceException()
  static async retry(postId: number, socialPostId: number): Promise<void> {
    await axios.post(`${POST_SERVICE}/${postId}/post_social_networks/${socialPostId}/retry`);
  }

  @scCatchServiceException()
  static async updateSocialPost(
    postId: number,
    socialPostId: number,
    payload: PostSocialNetworkUpdatePayload
  ): Promise<{ message?: string }> {
    const { data } = await axios.patch(`${POST_SERVICE}/${postId}/post_social_networks/${socialPostId}`, payload);
    return data;
  }
}
